import React, { createContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

export const SitesModalContext = createContext()

export const SitesModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [siteData, setSiteData] = useState(null)

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const setSite = setSiteData

  const contextValue = useMemo(() => ({
    isModalOpen,
    toggleModal,
    siteData,
    setSite
  }), [isModalOpen, siteData])

  return (
    <SitesModalContext.Provider value={contextValue}>
      {children}
    </SitesModalContext.Provider>
  )
}

SitesModalProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default SitesModalProvider
